  (function () {
    // Config travels on this script tag (see the snippet's comment).
    var me = document.currentScript;
    if (!me || !me.dataset.sectionId) return;
    var section = document.getElementById('shopify-section-' + me.dataset.sectionId);
    var root = section && section.querySelector('[data-section-carousel]');
    if (!root || root.__sectionCarouselBootstrapped) return;
    root.__sectionCarouselBootstrapped = true;
    var D = window.DFYNE = window.DFYNE || {};
    var src = me.dataset.carouselsSrc;

    function load() {
      if (D.sectionCarousels) { D.sectionCarousels.init(root); return; }
      if (D.sectionCarouselsRequested) return;
      D.sectionCarouselsRequested = true;
      var s = document.createElement('script');
      s.src = src;
      document.head.appendChild(s);
    }

    root.addEventListener('pointerenter', load, { once: true });
    root.addEventListener('touchstart', load, { once: true, passive: true });
    root.addEventListener('focusin', load, { once: true });
    root.addEventListener('click', function (event) {
      if (root.dataset.sectionCarouselInit !== 'true') {
        var button = event.target.closest('button');
        if (button && root.contains(button)) root.__sectionCarouselPendingClick = button;
      }
      load();
    });

    if ('IntersectionObserver' in window) {
      var gate = (D.heroReady && D.heroReady.then) ? D.heroReady : Promise.resolve();
      gate.then(function () {
        var io = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) { io.disconnect(); load(); return; }
          }
        }, { rootMargin: '300px 0px' });
        io.observe(root);
      }, load);
    } else if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', load, { once: true });
    } else {
      load();
    }
  })();
